<div [style.height.px]="rowHeight" class="point-btn" (click)="addNewPoint()">
  @if(serverSide === 1){
    @if(sideNumber == 1){
      <span [style.font-size.px]="rowHeight / 7.9">+1</span> 
    } @else {
      <span [style.font-size.px]="rowHeight / 12.6" [innerHTML]="serverNumber === 1? 'NEXT<br />SERVER' : 'SIDEOUT'"></span>    
    }
  }

  @if(serverSide === 2){
    @if(sideNumber == 2){
      <span [style.font-size.px]="rowHeight / 7.9">+1</span> 
    } @else {
      <span [style.font-size.px]="rowHeight / 12.6" [innerHTML]="serverNumber === 1 ? 'NEXT<br />SERVER' : 'SIDEOUT'"></span>    
    }
  }
</div>